import { createContext, useContext, ReactNode } from "react";
import { usePage } from "@inertiajs/react";
import type { TranslationDict, SharedProps } from "@/types";

const I18nContext = createContext<SharedProps>({ locale: "zh", translations: {} });

export function TranslationProvider({ children }: { children: ReactNode }) {
  const { locale, translations } = usePage().props;
  return (
    <I18nContext.Provider value={{ locale, translations }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useT() {
  const { translations, locale } = useContext(I18nContext);
  function t(key: string, vars?: Record<string, string | number>): string {
    const raw = key.split(".").reduce<string | TranslationDict | undefined>(
      (acc, k) => (acc && typeof acc === "object" ? acc[k] : undefined), translations);
    let str = typeof raw === "string" ? raw : key;
    if (vars) for (const [k, v] of Object.entries(vars)) str = str.replaceAll(`%{${k}}`, String(v));
    return str;
  }
  return { t, locale };
}
